import { render, staticRenderFns } from "./CharactersPage.vue?vue&type=template&id=1609e831&lang=pug&"
import script from "./CharactersPage.vue?vue&type=script&lang=ts&"
export * from "./CharactersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports